import { faDigits } from "../i18n/digits";
import { botOrdinal } from "./opponent-number";
import type { SeatPlayer } from "./seat-identity";

/** Solo / quick-match fill the other seats with bots — labelled by their POSITION among the bot
 *  seats («بات ۱» is the lowest-numbered bot chair, and reads the same on every screen). */
const BOT_NAME = "بات";

/**
 * The positional label for a بی‌دل seat with no known human — the `fallback` half of
 * {@link resolveSeatName}.
 *
 * ⚠️ IT LIVES IN ITS OWN MODULE ON PURPOSE. The felt and the end-of-match card must number the
 * same chair identically, and until 2026-08-29 they did not even use the same WORD: the table
 * said «بات ۲» while the result overlay said «ربات 2» — and said it about real people, because
 * it had no roster at all. Importing the screen module from the game container to share this
 * would couple them (and break every test that mocks `HeartsTable`), so the one implementation
 * sits here, where both can reach it.
 */
export function heartsSeatFallback(
  seat: number,
  you: number,
  seats: number,
  players: readonly SeatPlayer[] | undefined,
): string {
  // ISSUE B — the bot number is ABSOLUTE (its rank among the bot seats), so the same bot reads
  // the same «بات N» for every player, not a number relative to the viewer's own seat.
  const isBot = (s: number): boolean =>
    s !== you && !players?.some((pl) => pl.seat === s && !pl.isBot);
  return `${BOT_NAME} ${faDigits(botOrdinal(seat, seats, isBot))}`;
}
